import { trpc } from '@/shared/api';

/** 인쇄 방식 마스터 목록 조회. */
export const usePrintMethodsQuery = () => trpc.productManagement.printMethods.list.useQuery();
